import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { GalleryPage } from './pages/GalleryPage';
import { ReviewsPage } from './pages/ReviewsPage';
import { CareersPage } from './pages/CareersPage';
import { ContactPage } from './pages/ContactPage';
import { QuotePage } from './pages/QuotePage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Toaster position="top-center" richColors data-id="element-2" />
      <Routes data-id="element-3">
        <Route element={<Layout data-id="element-5" />} data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
          <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
          <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
          <Route path="/gallery" element={<GalleryPage data-id="element-13" />} data-id="element-12" />
          <Route path="/reviews" element={<ReviewsPage data-id="element-15" />} data-id="element-14" />
          <Route path="/careers" element={<CareersPage data-id="element-17" />} data-id="element-16" />
          <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
          <Route path="/quote" element={<QuotePage data-id="element-21" />} data-id="element-20" />
          <Route path="*" element={<HomePage data-id="element-23" />} data-id="element-22" />
        </Route>
      </Routes>
    </BrowserRouter>;
}